import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  padding: 24px 24px 0px 24px;

  border-radius: 8px 8px 0px 0px;

  & .location-filter-input-text {
    max-width: 200px !important;
  }
`;

export const Header = styled.div`
  width: 100%;

  padding: 12px 0px 0px 16px;
  font: ${(props) => props.theme.fonts?.h2};
`;

export const Content = styled.div`
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin-top: 28px;
  padding: 0px 16px;

  & > div {
    flex: 1 1 240px;

    margin-bottom: 40px;

    &:nth-child(odd) {
      margin-right: 24px;
    }

    max-width: 240px;
  }

  & .location-filter-list-results-container,
  & .location-filter-list-results-container-scroll {
    max-height: 170px;
  }

  & .location-filter-list-result {
    width: 290px;
  }

  & .location-filter-result-text {
    width: calc(100% - 45px);
  }

  margin-top: 28px;
  padding: 0px 16px;

  & > div {
    margin-bottom: 20px;

    &:not(:first-child, :nth-child(2)) {
      margin-top: 20px;
    }
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  :first-child {
    margin-right: 8px;
  }
`;

export const CalculationParametersBlock = styled.div`
  /* Full-width row: parent Content caps direct child divs at 240px; this block must span the popover. */
  && {
    flex: 0 0 100%;
    flex-basis: 100%;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin-right: 0 !important;
    margin-top: 0 !important;
    box-sizing: border-box;
  }

  padding-top: 20px;

  border-top: 1px solid ${(props) => props.theme.colors.greys.light};
`;

export const CalculationParametersTitle = styled.div`
  && {
    width: 100%;
    max-width: 100%;
    margin-bottom: 16px;
  }

  font: ${(props) => props.theme.fonts.textBigHeight16};
`;

export const CalculationToggleRow = styled(ToggleContainer)`
  flex-wrap: nowrap;

  && {
    width: 100%;
    max-width: 100%;
    margin-bottom: 16px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ToggleLabelRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;

  flex: 1;
  min-width: 0;
`;
